import './style.scss'

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CheckoutCheckbox from 'components/Checkout/CheckoutCheckbox'
import Link from 'components/UI/Link'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'

export class CartSmsNotification extends Component {
    render() {
        const { mobile, deliverySms, t } = this.props
        const sendToText = () =>
            deliverySms
                ? t('cartSmsNotificationSendTo', { mobile })
                : t('cartSmsNotificationRegisteredNumber', { mobile })
        const linkText = mobile
            ? t('cartSmsNotificationChangeNumber')
            : t('cartSmsNotificationAddNumber')
        return (
            <div className="cart-sms">
                <CheckoutCheckbox
                    checked={deliverySms}
                    disabled={!mobile}
                    onChange={() =>
                        mobile &&
                        this.props.dispatch({
                            type: 'SET_SMS_OPT-IN',
                            payload: !deliverySms,
                        })
                    }
                >
                    <div className="cart-sms__label">
                        <div>{t('formsPersonalInfoFormAcceptSMS')}</div>
                        <div className="cart-sms__subtext">
                            <span>
                                {mobile && `${sendToText()} `}
                                <Link to={'/checkout/contactinfo'}>{linkText}</Link>
                            </span>
                        </div>
                    </div>
                </CheckoutCheckbox>
            </div>
        )
    }
}

CartSmsNotification.propTypes = {
    dispatch: PropTypes.func,
    deliverySms: PropTypes.bool,
    mobile: PropTypes.string,
    t: PropTypes.func,
}

const mapStateToProps = ({ personalInfo }) => ({
    deliverySms: personalInfo.deliverySms,
    mobile: personalInfo.mobile,
})

export default connect(mapStateToProps)(withTranslation()(CartSmsNotification))
